<template>
<div>

<vs-popup class="holamundo success-popups" :title="title"
          :active.sync="SuccessQuestionnaire">
          <figure>
            <img src="@/assets/images/main/icon-note.svg" alt="login" class="mx-auto" />
            
          </figure>
          <h2 class="title">{{msg}}</h2>
          <p></p>
        </vs-popup>

</div>
</template>
<script>
export default { 
    
    data() {
      return {
          SuccessQuestionnaire:false,
          statuesCode:"",
          title:'QuickBooks Configuration status',
          msg:""
      }
    },
      mounted() {
          this.SuccessQuestionnaire = true;
          this.statuesCode = this.checkProperty(this.$route.query ,'status_code');
          if(this.statuesCode  == "SUCCESS" ){
            this.msg = "QuickBooks Configured successfully!";

          }else{
            this.msg ="Somthing went wrong!";
          }
          // document.addEventListener("click", this.reloadpage);
      },
    methods:{
      reloadpage() {
        this.SuccessQuestionnaire = false;
     
      setTimeout(() => {

          this.$router.push("/dashboard");
       } ,10)
    },
    },
    watch: {
      SuccessQuestionnaire: function (value) {
        if(!value){
          // this.$router.push("/basic-settings");
          setTimeout(() => {
            // this.$router.push("/basic-settings");
          })
        }
    }
  }
}
</script>